import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxDateBoxComponent,
  DxLoadPanelComponent,
  DxLookupComponent,
  DxNumberBoxComponent,
  DxPopupComponent,
  DxTextAreaComponent,
  DxTextBoxComponent,
  DxValidationGroupComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { AnnotationType } from 'devextreme/common/charts';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import {
  TIPI_PROPRIETA_ARTICOLO_LIST,
  TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO,
  TIPO_PROPRIETA_ARTICOLO_DATA,
  TIPO_PROPRIETA_ARTICOLO_NUMERO,
  TIPO_PROPRIETA_ARTICOLO_SELMULTI,
} from 'src/app/consts/tipi-proprieta-articolo';
import { Articoli } from 'src/app/models/articoli';
import { ArticoliMatricola } from 'src/app/models/articoli-matricola';
import { CausaliMovMag } from 'src/app/models/causali-movmag';
import {
  MovimentiMagazzino,
  PostMovimentiMagazzinoMatricola,
} from 'src/app/models/movimenti-magazzino';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { CausaliMovmagService } from 'src/app/shared/services/causali-movmag.service';
import { MovimentiMagazzinoService } from 'src/app/shared/services/movimenti-magazzino.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-magazzino-new-movimento',
  templateUrl: './magazzino-new-movimento.component.html',
  styleUrls: ['./magazzino-new-movimento.component.scss'],
  imports: [
    DxLoadPanelComponent,
    DxButtonComponent,
    DxTextBoxComponent,
    DxTextAreaComponent,
    DxLookupComponent,
    DxNumberBoxComponent,
    DxValidatorComponent,
    DxDateBoxComponent,
    DxDataGridComponent,
    DxPopupComponent,
    DxValidationGroupComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoEditingComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent,
    DxoTextsComponent,
  ],
  standalone: true,
})
export class MagazzinoNewMovimentoComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private navService = inject(NavigatorService);
  private tipiArticoliService = inject(TipiArticoliService);
  private causaliService = inject(CausaliMovmagService);
  private articoliService = inject(ArticoliService);
  private movMagService = inject(MovimentiMagazzinoService);
  private articoliMatService = inject(ArticoliMatricolaService);
  @ViewChild('dataGridArticoliMatricola', { static: false })
    dataGridArticoliMatricola: DxDataGridComponent;
  readonly listTipiProps = TIPI_PROPRIETA_ARTICOLO_LIST;
  readonly TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO =
    TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO;
  readonly TIPO_PROPRIETA_ARTICOLO_NUMERO = TIPO_PROPRIETA_ARTICOLO_NUMERO;
  readonly TIPO_PROPRIETA_ARTICOLO_DATA = TIPO_PROPRIETA_ARTICOLO_DATA;
  readonly TIPO_PROPRIETA_ARTICOLO_SELMULTI = TIPO_PROPRIETA_ARTICOLO_SELMULTI;

  gestMatricole: boolean; // definisce se è attivo il modulo matricole

  loadPanelVisible: boolean = false;
  shoPopUpGeneraMatricole: boolean = false; // popup gestione generazione matricole
  nuovoMovimentoMag = new MovimentiMagazzino();

  listTipiArticoli: TipiArticoli[] = [];
  listArticoli: any;
  listCausali: any;
  gestisciMatricola = false;
  listMatricoleArticoloDb: any[]; // lista della matricole assegnate all'articolo presente nel DB
  listArticoliMatricola: any[];
  listArticoliMatricolaProcessed = [];
  listPropsArtMatricola: any[];
  listPropsArtNewMatricola: any[];
  causaleInserimento: CausaliMovMag;

  listMatricoleDisponibili: any[];

  dataMovimento: Date;
  dataScadenzaMatricole: Date;

  constructor() {
    super();
    this.gestMatricole = this.isModVisible('Matricole');
    this.onSalvaClick = this.onSalvaClick.bind(this);
  }

  ngOnInit() {
    this.loadLookups();
  }

  loadLookups() {
    this.causaliService.getCausaleMovMagDefInsTemp().subscribe({
      next: (res) => {
        this.causaleInserimento = res;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify(
            'Errore caricamento causale inserimento default',
            'error',
            3000,
          );
        }
      },
    });

    this.causaliService.getListCausaliMovMagTemp().subscribe({
      next: (res) => {
        this.listCausali = {
          store: {
            type: 'array',
            data: res
              .filter((x) => x.visibilePerMovimentazione == true)
              .sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1)),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento causali', 'error', 3000);
        }
      },
    });

    this.articoliService.listTemp().subscribe({
      next: (res) => {
        this.listArticoli = {
          store: {
            type: 'array',
            data: res.filter(x => x.attivo == true),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      }
    });

    this.tipiArticoliService.getListTipiArticoliTemp().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento tipi articoli', 'error', 3000);
        }
      },
    });
  }

  //SALVA
  onSalvaClick(e: any) {
    const result = e.validationGroup.validate('form-dati');
    if (!result.isValid) {
      return;
    }

    this.nuovoMovimentoMag.data = moment(this.dataMovimento).utc(true).toDate();
    if (this.gestisciMatricola) {
      this.dataGridArticoliMatricola.instance.saveEditData();
      const checkResult = this.checkDatiMatricola();
      if (checkResult) {
        const obj = new PostMovimentiMagazzinoMatricola();
        obj.movimentoMagazzino = this.nuovoMovimentoMag;
        obj.listArticoliMatricola = this.buildPostListObj();
        this.loadPanelVisible = true;
        this.movMagService.postMovMagMatricole(obj).subscribe({
          next: () => {
            this.loadPanelVisible = false;
            notify(
              'Movimento magazzino per articoli matricola inseriti correttamente',
              'success',
              3000,
            );
            //this.popupAddMovMagazzinoEventEmitter.next(res);
            this.navService.goToMovimentazioni(); //Torno all'elenco delle movimentazioni
          },
          error: (error) => {
            this.loadPanelVisible = false;
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify('Errore salvataggio dati movimento', 'error', 3000);
            }
          },
        });
      }
    } else {
      this.loadPanelVisible = true;
      this.movMagService.post(this.nuovoMovimentoMag).subscribe({
        next: () => {
          this.loadPanelVisible = false;
          notify('Movimento magazzino inserito correttamente', 'success', 3000);
          //this.popupAddMovMagazzinoEventEmitter.next(res);
          this.navService.goToMovimentazioni(); //Torno all'elenco delle movimentazioni
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore salvataggio dati movimento', 'error', 3000);
          }
        },
      });
    }
  }

  onEsciClick() {
    this.navService.goToMovimentazioni(); //Torno all'elenco delle movimentazioni
  }

  //FORM
  onValueArticoloChanged() {
    if (
      this.nuovoMovimentoMag.idCausale > 0 &&
      this.nuovoMovimentoMag.idArticolo > 0 &&
      this.nuovoMovimentoMag.qta > 0
    ) {
      this.loadMatricoleArticolo();
      this.prepareGestMatricola();
    }
  }

  onValueCausaleChanged() {
    if (
      this.nuovoMovimentoMag.idCausale > 0 &&
      this.nuovoMovimentoMag.idArticolo > 0 &&
      this.nuovoMovimentoMag.qta > 0
    ) {
      this.loadMatricoleArticolo();
      this.prepareGestMatricola();
    }
  }

  onValueQtaChanged() {
    if (
      this.nuovoMovimentoMag.idCausale > 0 &&
      this.nuovoMovimentoMag.idArticolo > 0 &&
      this.nuovoMovimentoMag.qta > 0
    ) {
      this.loadMatricoleArticolo();
      this.prepareGestMatricola();
    }
  }

  //MATRICOLE
  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'preferences',
        text: 'Genera matricole', // <-- testo accanto all'icona
        type: 'success', // meglio usare "type" invece di class
        hint: 'Genera matricole', // tooltip
        onClick: this.genrazioneMatricoleClick.bind(this),
      },
    });
  }

  genrazioneMatricoleClick() {
    this.shoPopUpGeneraMatricole = true;
  }

  prepareGestMatricola() {
    const articolo = this.listArticoli.store.data.find(
      (a: any) => a.id == this.nuovoMovimentoMag.idArticolo,
    );
    const tipologia = this.listTipiArticoli.find(
      (t) => t.id == articolo.idTipo,
    );
    //Prelevo le matricole possibili per l'articolo
    this.articoliMatService.list().subscribe({
      next: res=>{
        this.listMatricoleArticoloDb = res.filter(x => x.idArticolo == articolo.id);
      },
      error: err=>{
        if(err?.error?.title){
          notificaMessaggio(err.error.title, "error");
        }
        else{
          notificaMessaggio("Errore recupero lista matricole", "error");
        }
      }
    })
    if (tipologia.usaMatricola && this.gestMatricole) {
      this.gestisciMatricola = true;
      if (this.nuovoMovimentoMag.idCausale == this.causaleInserimento.id) {
        this.listPropsArtMatricola = JSON.parse(tipologia.propJSON);
        this.listPropsArtNewMatricola = JSON.parse(tipologia.propJSON);

        if (!this.listArticoliMatricola) {
          this.listArticoliMatricola = [];
          for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
            const newArtMatricola = {
              index: _i + 1,
              matricola: '',
              idArticolo: this.nuovoMovimentoMag.idArticolo,
              dismesso: false,
              props: [],
              idTipologia: articolo.idTipo,
              dataScadenza: null,
            };
            this.listArticoliMatricola.push(newArtMatricola);
          }
        } else {
          const temp = this.listArticoliMatricola;
          this.listArticoliMatricola = [];
          for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
            if (temp[_i]) {
              const newArtMatricola = {
                index: _i + 1,
                matricola: temp[_i].matricola,
                idArticolo: this.nuovoMovimentoMag.idArticolo,
                dismesso: false,
                props:
                  temp[_i].idTipologia == articolo.idTipo ? temp[_i].props : [],
                idTipologia: articolo.idTipo,
                dataScadenza: null,
              };
              this.listArticoliMatricola.push(newArtMatricola);
            } else {
              const newArtMatricola = {
                index: _i + 1,
                matricola: '',
                idArticolo: this.nuovoMovimentoMag.idArticolo,
                dismesso: false,
                props: [],
                idTipologia: articolo.idTipo,
                dataScadenza: null,
              };
              this.listArticoliMatricola.push(newArtMatricola);
            }
          }
        }
      } else {
        if (
          !this.listMatricoleDisponibili ||
          this.listMatricoleDisponibili.length == 0 ||
          this.listMatricoleDisponibili[0].idArticolo != articolo.id
        ) {
          this.articoliMatService.listDisponibili(articolo.id).subscribe({
            next: (res) => {
              this.listMatricoleDisponibili = res.sort((a, b) =>
                a.matricola < b.matricola ? -1 : 1,
              );
            },
            error: (error) => {
              if (error?.status == 500 && error?.error?.title) {
                notify(error?.error?.title, 'warning');
              } else {
                notify(
                  'Errore caricamento matricole disponibili',
                  'error',
                  3000,
                );
              }
            },
          });
        }
        if (!this.listArticoliMatricola) {
          this.listArticoliMatricola = [];
          for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
            const newArtMatricola = {
              index: _i + 1,
              id: 0,
              idTipologia: articolo.idTipo,
            };
            this.listArticoliMatricola.push(newArtMatricola);
          }
        } else {
          const temp = this.listArticoliMatricola;
          this.listArticoliMatricola = [];
          for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
            if (temp[_i]) {
              const newArtMatricola = {
                index: _i + 1,
                id: temp[_i].idTipologia == articolo.idTipo ? temp[_i].id : 0,
                idTipologia: articolo.idTipo,
              };
              this.listArticoliMatricola.push(newArtMatricola);
            } else {
              const newArtMatricola = {
                index: _i + 1,
                id: 0,
                idTipologia: articolo.idTipo,
              };
              this.listArticoliMatricola.push(newArtMatricola);
            }
          }
        }
      }
    } else {
      this.gestisciMatricola = false;
    }
  }

  parseProps(jsonProps: any) {
    if (this.nuovoMovimentoMag.idCausale == this.causaleInserimento.id) {
      const props = JSON.parse(jsonProps);
      props.forEach((element: any) => {
        element.valore = null;
      });
      return props;
    }
    return null;
  }

  getDataType(tipo: number) {
    if (tipo == TIPO_PROPRIETA_ARTICOLO_NUMERO) {
      return 'number';
    } else if (tipo == TIPO_PROPRIETA_ARTICOLO_DATA) {
      return 'date';
    }
    return 'string';
  }

  getDataFormat(tipo: number) {
    if (tipo == TIPO_PROPRIETA_ARTICOLO_NUMERO) {
      return '0';
    } else if (tipo == TIPO_PROPRIETA_ARTICOLO_DATA) {
      return 'dd/MM/yyyy';
    }
    return '';
  }

  checkDatiMatricola() {
    const resDuplicati = this.checkDuplicatiMatricola();
    const resDatiObbligatori = this.checkDatiObbligatori();
    return resDuplicati && resDatiObbligatori;
  }

  checkDuplicatiMatricola() {
    if (this.nuovoMovimentoMag.idCausale == this.causaleInserimento.id) {
      const listMatricole = this.listArticoliMatricola.map(function (item) {
        return item.matricola.trim();
      });
      const findDuplicates = listMatricole.some(
        (item, index) => listMatricole.indexOf(item) !== index,
      );
      if (findDuplicates) {
        notificaMessaggio(
          'Non è consentito inserire 2 o più matricole uguali',
          'warning',
        );
        //this.notificaMess("Non è consentito inserire 2 o più matricole uguali", "warning");
        return false;
      }
      return true;
    } else {
      const listIdsArtMat = this.listArticoliMatricola.map(function (item) {
        return item.id;
      });
      const findDuplicates = listIdsArtMat.some(
        (item, index) => listIdsArtMat.indexOf(item) !== index,
      );
      if (findDuplicates) {
        notificaMessaggio(
          'Non è consentito selezionare 2 articoli matricola uguali',
          'warning',
        );
        //this.notificaMess("Non è consentito selezionare 2 articoli matricola uguali", "warning");
        return false;
      }
      return true;
    }
  }

  checkDatiObbligatori() {
    let ret = true;
    if (this.nuovoMovimentoMag.idCausale == this.causaleInserimento.id) {
      for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
        const tempArtMat = this.listArticoliMatricola[_i];
        if (!tempArtMat.matricola) {
          notificaMessaggio(
            'Inserire matricola per articolo ' + (_i + 1),
            'warning',
          );
          //this.notificaMess("Inserire matricola per articolo " + (_i + 1), "warning");
          ret = false;
        }
        this.listPropsArtMatricola?.forEach((element) => {
          if (element.obbligatorio && !tempArtMat.props[element.nome]) {
            notificaMessaggio(
              'Proprieta ' +
                element.nome +
                ' obbligatoria per articolo ' +
                (_i + 1),
              'warning',
            );
            //this.notificaMess("Proprieta " + element.nome + " obbligatoria per articolo " + (_i + 1), "warning");
            ret = false;
          }
        });
      }
    }
    return ret;
  }

  convertDataMapped(currentProps: any, propsTipo: any) {
    const origData: any[] = [];
    propsTipo?.forEach((element: any) => {
      const newData = {
        nome: element.nome,
        tipo: element.tipo,
        obbligatorio: element.obbligatorio,
        controlloNotifica: element.controlloNotifica,
        selMultiplaDati: element.selMultiplaDati,
        valore: currentProps[element.nome],
      };
      origData.push(newData);
    });
    return JSON.stringify(origData);
  }

  buildPostListObj() {
    const ret: ArticoliMatricola[] = [];
    this.listArticoliMatricola.forEach((element) => {
      let tempArtMat = new ArticoliMatricola();
      if (element.id > 0) {
        tempArtMat = this.listMatricoleDisponibili.find(
          (m) => m.id == element.id,
        );
      } else {
        tempArtMat.idArticolo = element.idArticolo;
        tempArtMat.matricola = element.matricola;
        tempArtMat.dataScadenza = element.dataScadenza;
        //tempArtMat.propJson = this.convertDataMapped(element.props, this.listPropsArtMatricola);
        tempArtMat.propJson = JSON.stringify(element.props);
        tempArtMat.dismesso = element.dismesso;
      }
      ret.push(tempArtMat);
    });
    return ret;
  }

  loadMatricoleArticolo() {
    if (this.nuovoMovimentoMag.idArticolo) {
      this.articoliMatService
        .list(this.nuovoMovimentoMag.idArticolo)
        .subscribe({
          next: (res) => {
            this.listMatricoleDisponibili = res;
          },
          error: (error) => {
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify('Errore caricamento ', 'error', 3000);
            }
          },
        });
    }
  }

  generaMatricole(e: any) {
    const resultf = e.validationGroup.validate('form-genera-matricole');
    if (!resultf.isValid) {
      return;
    }

    const result = confirm(
      '<i>Procedere con la generazione delle matricole?</i>',
      'Generazione matricole',
    );
    result.then((dialogResult) => {
      if (dialogResult) {
        this.shoPopUpGeneraMatricole = false;
        //Clean lista
        this.listArticoliMatricola = this.listArticoliMatricola.map(
          (item, i) => ({
            ...item,
            index: i + 1,
            matricola: '',
            props: [],
            dataScadenza: null,
          }),
        );

        // Recupero i valori della matricole
        const valori = this.listMatricoleArticoloDb
          .map((x) => Number(x.matricola))
          .filter((n) => !isNaN(n)); // Matricola è un campo stringa - escludo i valori non numerici

        let startMatricola = 1;

        //Recupero il max
        if (valori.length > 0) {
          const maxVal = Math.max(...valori);
          startMatricola = maxVal + 1;
        }

        // Genera matricole
        let progressivo = startMatricola;

        this.listArticoliMatricola = this.listArticoliMatricola.map(
          (item, i) => ({
            ...item,
            index: i + 1,
            matricola: String(progressivo++),
            dataScadenza: moment(this.dataScadenzaMatricole).utc(true).toDate(),
            props: this.listPropsArtNewMatricola,
          }),
        );

        //console.log(JSON.stringify(this.listArticoliMatricola));

        //Ricreo l'oggetto per visualizzare i valori nei campi (non recupera correttamente props.valore nella dafiedld della grid)
        this.listArticoliMatricola = this.listArticoliMatricola.map((item) => {
          const obj = { ...item };
          if (Array.isArray(item.props)) {
            item.props.forEach((p: any) => {
              obj[p.nome] = p.valore; // es: obj["colore"] = "rosso"
            });
          }

          return obj;
        });

        this.listArticoliMatricolaProcessed = this.listArticoliMatricola.map(
          (item) => {
            const obj = { ...item }; // copia tutti i campi originali

            // aggiungo solo i valori del props
            if (Array.isArray(item.props)) {
              item.props.forEach((p: any) => {
                obj[p.nome] = p.valore;
              });
            }

            return obj;
          },
        );

        //console.log(JSON.stringify(this.listArticoliMatricola));
      }
    });
  }

  getCellValue = (rowData: any, column: any) => {
    const propName = column.caption; // nome proprietà = caption
    if (rowData.props && rowData.props.nome === propName) {
      return rowData.props.valore;
    }
    return null;
  };

  //ARTICOLI
  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }

    return (
      item.tipo.descrizione +
      ' - ' +
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }
}
